/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DeliveryHandoffInstructions = {
    HAND_IT_TO_ME: 'HAND_IT_TO_ME',
    LEAVE_IT_AT_MY_DOOR: 'LEAVE_IT_AT_MY_DOOR',
    OTHER: 'OTHER'
} as const;
export type DeliveryHandoffInstructions = typeof DeliveryHandoffInstructions[keyof typeof DeliveryHandoffInstructions];


export function instanceOfDeliveryHandoffInstructions(value: any): boolean {
    for (const key in DeliveryHandoffInstructions) {
        if (Object.prototype.hasOwnProperty.call(DeliveryHandoffInstructions, key)) {
            if (DeliveryHandoffInstructions[key as keyof typeof DeliveryHandoffInstructions] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DeliveryHandoffInstructionsFromJSON(json: any): DeliveryHandoffInstructions {
    return DeliveryHandoffInstructionsFromJSONTyped(json, false);
}

export function DeliveryHandoffInstructionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeliveryHandoffInstructions {
    return json as DeliveryHandoffInstructions;
}

export function DeliveryHandoffInstructionsToJSON(value?: DeliveryHandoffInstructions | null): any {
    return value as any;
}

export function DeliveryHandoffInstructionsToJSONTyped(value: any, ignoreDiscriminator: boolean): DeliveryHandoffInstructions {
    return value as DeliveryHandoffInstructions;
}

